// Shared enumerations (file-upload, project-lifecycle, accounts, planning)
// moved to @autoriz/shared in feature 240. Re-exported here so existing
// `@/utils/enums` imports keep working. New code SHOULD import directly
// from the appropriate @autoriz/shared subpath.

export {
  ProjectFileUsage,
  ProjectFileSection,
  FileMimeType,
} from '@autoriz/shared/files'
export type {
  ProjectFileUsageType,
  ProjectFileSectionType,
} from '@autoriz/shared/files'

export {
  ProjectStep,
  FormStatus,
  PaymentMode,
} from '@autoriz/shared/project'
export type {
  ProjectStepType,
  FormStatusType,
  PaymentModeType,
} from '@autoriz/shared/project'

export { AccountType } from '@autoriz/shared/accounts'
export type { AccountTypeType } from '@autoriz/shared/accounts'

export { PlanningFileType } from '@autoriz/shared/planning'
export type { PlanningFileTypeType } from '@autoriz/shared/planning'

// Frontend-specific enum: narrow 6-member set used only by
// `src/utils/config.ts#ProjectFormName`. Intentionally NOT moved to shared —
// it is a subset of the shared `ProjectFormStatusType` with different UI
// semantics. `as const` (per constitution III) replaces the prior TS enum.
export const ProjectFormType = {
  DECLARER: 'DECLARER',
  LAND: 'LAND',
  EXISTING_BUILDING: 'EXISTING_BUILDING',
  VERANDA: 'VERANDA',
  PERGOLA: 'PERGOLA',
  POOL: 'POOL',
} as const
export type ProjectFormType = (typeof ProjectFormType)[keyof typeof ProjectFormType]

// Tiny helper class retained here for legacy callers that construct
// JSON-serialisable wrappers around enum values.
export class EnumClass {
  value: string

  constructor(value: string) {
    this.value = value
  }

  toJSON() {
    return this.value
  }
}
